import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool } from '@/tool'
import 'antd/dist/antd.css';
let { WizContainer, WizReduxTemplatem, modelUtils } = framework_tool;
import { ExportExcel } from '@/components/index'
let { WizCard, WizLayout, WizIcon,WizSpin,WizTypography } = component_tool;
const { Paragraph } = WizTypography;


class ThirdCorpUserImport extends WizContainer {

  componentName = 'ThirdCorpUserImport';

  constructor(props) {
    super(props);
    this.state = {}
  }


  _handleImport(nextProps, nextState) {
    let o = nextProps['imports']
    if (o['success']) {
      let data = o['data'];
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{data}</p>
          </div>
        ),
      })
      this.props.changeModal(false, true);
      return true;
    } else {
      wizNotice.error(o['msg'] || "导入数据出错，请联系相关人员")
      return false;
    }
  }

  propsAndStateOnChange = {
    imports: this._handleImport.bind(this),
  }


  _render() {
    let {corpInfoId} = this.props;
    console.log(this.props)
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '第三方企业人员导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_thirdCorpUserTemp,
      }

    }
    let submit = (file, fileData) => {
      let apiPath = 'thirdCorpUser/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            corpInfoId,
            fileData
          }
        }
      });
    }
    return (
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const { thirdCorpUser } = state;
  const imports = modelUtils.getModelEntity(thirdCorpUser, 'import');
  return {
    imports: imports,
  }
};

const options = { withRef: true };

export default connect(mapStateToProps,null, null, options)(ThirdCorpUserImport);
